import React, { useState } from "react";
import { Card, Col, Row, Button, Form } from "react-bootstrap";
import { useQuery } from "react-query";
import { Bar, Line, Pie, Doughnut } from "react-chartjs-2";
import { 
  Chart as ChartJS, 
  CategoryScale, 
  LinearScale, 
  BarElement, 
  Title, 
  Tooltip, 
  Legend, 
  PointElement, 
  LineElement, 
  ArcElement
} from 'chart.js';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TopBar from "../Menu/TopMenu";
import { GetReports } from "../../Services/Reports";
import { GetSubscribersApi } from "../../Services/UserApi";
import { convertToDate } from "../../common/SupportingMethods";
import LoadingSpin from "../../common/Spinner";
import { BiSearchAlt } from "react-icons/bi";
import { getSubscriberId } from "../../common/GetUserData";

ChartJS.register(
  CategoryScale, 
  LinearScale, 
  BarElement, 
  Title, 
  Tooltip, 
  Legend, 
  PointElement, 
  LineElement, 
  ArcElement
);
const ReportCard = ({ title, data, itemMapper, extraStyles, options, chartType = "bar" }) => {
  const items = itemMapper(data);
  const labels = items.map(item => item.label);

  const colors = [
    'rgba(255, 99, 132, 0.2)',  // Red
    'rgba(54, 162, 235, 0.2)',  // Blue
    'rgba(255, 206, 86, 0.2)',  // Yellow
    'rgba(75, 192, 192, 0.2)',  // Green
    'rgba(153, 102, 255, 0.2)', // Purple
    'rgba(255, 159, 64, 0.2)'   // Orange
  ];

  const borderColors = [
    'rgba(255, 99, 132, 1)',
    'rgba(54, 162, 235, 1)',
    'rgba(255, 206, 86, 1)',
    'rgba(75, 192, 192, 1)',
    'rgba(153, 102, 255, 1)',
    'rgba(255, 159, 64, 1)'
  ];

  const chartData = {
    labels,
    datasets: [
      {
        // label: title,
        data: items.map(item => item.value),
        backgroundColor: colors.slice(0, labels.length), // Use the first N colors for N labels
        borderColor: borderColors.slice(0, labels.length),
        borderWidth: 1,
      },
    ],
  };

  let ChartComponent;
  switch (chartType) {
    case "doughnut":
      ChartComponent = Doughnut;
      break;
    case "line":
      ChartComponent = Line;
      break;
    case "pie":
      ChartComponent = Pie;
      break;
    default:
      ChartComponent = Bar;
  }

  return (
    <Col md={6} className="mb-4">
      <Card className="report-card" style={{ minHeight: '350px', minWidth: '350px', ...extraStyles }}>
        <Card.Header style={{ fontWeight: 'bold', textAlign: 'center' }}>{title}</Card.Header>
        <div style={{ padding: '20px', width: '100%' }}>
          <ChartComponent data={chartData} options={options} style={{ height: '250px' }} />
        </div>
      </Card>
    </Col>
  );
};


const Reports = () => {
  const currentDate = new Date();
  const [subscriber, setSubscriber] = useState(getSubscriberId());
  const [reqStartDate, setReqStartDate] = useState(currentDate);
  const [reqEndDate, setReqEndDate] = useState(currentDate);
  const [searchClicked, setSearchClicked] = useState(false);


  function onChangeHandler(value) {
    setReqStartDate(value[0]);
    if (value[1] === null) setReqEndDate(reqStartDate);
    setReqEndDate(value[1]);
    if (value[0] && value[1]) {
      setReqStartDate(value[0]);
      setReqEndDate(value[1]);
    }
  }
  const { data: subData } = useQuery(['getSubscribers'], {
    refetchOnWindowFocus: false,
    queryFn: () => GetSubscribersApi(),
  });

  const { data: reportData, refetch, isFetching } = useQuery(['getReports'], {
    refetchOnWindowFocus: false,
    queryFn: () => GetReports(subscriber, convertToDate(reqStartDate), convertToDate(reqEndDate)),
  });

  const handleSearch = () => {
    setSearchClicked(true);
    refetch();
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      // title: {
      //   display: true,
      //   text: 'Report Data',
      // },
    },
  };
  const chartOptions1 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display : false,
        position: 'top',
      },
      // title: {
      //   display: true,
      //   text: 'Report Data',
      // },
    },
  };
  return (
    <div className="m-3">
      <TopBar pageTitle={"Reports"} />
      <div
        className="d-flex justify-content-start align-items-center py-4"
        style={{ border: "1px solid #ccc", borderRadius: "10px" }}
      >
        <Form.Group className="mx-4" style={{ maxWidth: "200px" }}>
          <Form.Label style={{ fontWeight: "bold" }}>Select Subscriber</Form.Label>
          <Form.Select value={subscriber} onChange={(e) => setSubscriber(e.target.value)}>
            <option value="">All</option>
            {subData?.map((sub) => (
              <option key={sub.ID} value={sub.ID}>
                {sub.NAME}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group className="d-flex flex-column align-items-start me-3 mx-3" style={{ zIndex: 1000 }}>
          <Form.Label
            htmlFor="dateRange"
            className="form-label"
            style={{ fontWeight: "bold" }}
          >
            Select Date
          </Form.Label>
          <DatePicker
              id="dateStartEnd"
              selectsRange={true}
              startDate={reqStartDate}
              endDate={reqEndDate}
              onChange={onChangeHandler}
              className="form-control form-control-sm"
              showDisabledMonthNavigation
              maxDate={new Date()}
              style={{ height: "600px" }}
            />
        </Form.Group>
        <Button
          className="mt-4 ms-3"
          variant="dark"
          disabled={isFetching}
          onClick={handleSearch}
        >
          {isFetching ? <LoadingSpin /> : "Search"}
        </Button>
      </div>
      <div style={{ overflowX: 'hidden', height: '470px', overflowY: 'auto', marginTop: '20px' }}>
        {reportData?.length > 0 ? (
          <Row className="mt-4">
            <ReportCard
              title="Channels"
              data={reportData[0]?.Channels[0]}
              itemMapper={(data) => [
                { label: 'QINOTIFY', value: data?.QINOTIFY },
                { label: 'VIBER', value: data?.VIBER },
                { label: 'WHATSAPP', value: data?.WHATSAPP },
                { label: 'SMS', value: data?.SMS }
              ]}
              chartType="bar" // Use a bar chart
              options={chartOptions1}
            />
            <ReportCard
              title="Operators"
              data={reportData[0]?.Operators[0]}
              itemMapper={(data) => [
                { label: 'ASIA', value: data?.ASIA },
                { label: 'ZAIN', value: data?.ZAIN },
                { label: 'KOREK', value: data?.KOREK },
                { label: 'OTHER', value: data?.OTHER }
              ]}
              chartType="line"
              options={chartOptions1}
            />
            
            <ReportCard
              title="Segments"
              data={reportData[0]?.Segments[0]}
              itemMapper={(data) => [
                { label: 'ZAIN_SEGS', value: data?.ZAIN_SEGS },
                { label: 'ASIA_SEGS', value: data?.ASIA_SEGS },
                { label: 'KOREK_SEGS', value: data?.KOREK_SEGS },
                { label: 'OTHER_SEGS', value: data?.OTHER_SEGS }
              ]}
              chartType="doughnut"
              options={chartOptions}
            />
            <ReportCard
              title="Non Segments"
              data={reportData[0]?.Operators[0]}
              itemMapper={(data) => [
                { label: 'ASIA', value: data?.ASIA },
                { label: 'ZAIN', value: data?.ZAIN },
                { label: 'KOREK', value: data?.KOREK },
                { label: 'OTHER', value: data?.OTHER }
              ]}
              chartType="pie"
              options={chartOptions}
            />
            <ReportCard
              title="Categories"
              data={reportData[0]?.Categories[0]}
              itemMapper={(data) => [
                { label: 'OTP', value: data?.OTP },
                { label: 'AUTHORISATION', value: data?.AUTHORISATION },
                { label: 'NOTIFICATION', value: data?.NOTIFICATION },
                { label: 'MCOTP', value: data?.MCOTP }
              ]}
              chartType="pie"
              options={chartOptions}
            />
            <ReportCard
              title="SMS Vendors"
              data={reportData[0]?.Vendors[0]?.SMS_VENDORS}
              itemMapper={(data) => data.map(vendor => ({ label: vendor.VENDOR_NAME || 'Unknown Vendor', value: vendor.COUNT }))}
              chartType="bar"
              options={chartOptions1}
            />
            <ReportCard
              title="WhatsApp Vendors"
              data={reportData[0]?.Vendors[0]?.WHATSAPP_VENDORS}
              itemMapper={(data) => data.map(vendor => ({ label: vendor.VENDOR_NAME || 'Unknown Vendor', value: vendor.COUNT }))}
              chartType="pie"
              options={chartOptions}
            />
            <ReportCard
              title="Viber Vendors"
              data={reportData[0]?.Vendors[0]?.VIBER_VENDORS}
              itemMapper={(data) => data.map(vendor => ({ label: vendor.VENDOR_NAME || 'Unknown Vendor', value: vendor.COUNT }))}
              chartType="pie"
              options={chartOptions}
            />
            <ReportCard
              title="Message Codes"
              data={reportData[0]?.Vendors[0]?.MSG_CODES.sort((a, b) => a.MSG_CODE - b.MSG_CODE)}
              itemMapper={(data) => data.map(vendor => ({ label: vendor.MSG_CODE, value: vendor.COUNT }))}
              chartType="line" 
              //extraStyles={{ width: '51.3rem' }}
              options={chartOptions1}
            />

          </Row>
        ) : (
          <div className="d-flex flex-column align-items-center justify-content-center my-5 py-5"
            style={{ fontFamily: "sans-serif" }}>
            <BiSearchAlt size={"60px"} />
            <h4>No data Found</h4>
          </div>
        )}
      </div>
    </div>
  );
};

export default Reports;
